import { Link, useNavigate, useParams } from 'react-router-dom';
import { FC, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Typography } from '@mui/material';
// import { useParams } from 'react-router-dom';
import { getOrderByNumber } from '../../api/apis';
import { IOrder } from '../../lib/interfaces/Order';
import Loader from '../Simple/Loader/Loader';
import { ProductStatus } from './payment.consts';
import './PaymentPage.scss';
import paths from '@/lib/consts/paths';
import useUserMeQuery from '@/reactQuery/hooks/useUserMeQuery';

const SubscriptionPayment: FC = () => {
	const { orderNumber = '' } = useParams();
	const [isRetryLoading, setIsRetryLoading] = useState<boolean>(false);
	const [orderRetries, setOrderRetries] = useState<number>(0);
	const [error, setError] = useState<boolean>(false);
	const navigate = useNavigate();
	const { refetch: refetchUser } = useUserMeQuery();

	const refetchAfterTimeout = (refetchFn: () => void) => {
		setIsRetryLoading(true);
		setTimeout(() => {
			setOrderRetries((prevRetries) => prevRetries + 1);
			refetchFn();
		}, orderRetries * 1000 + 1000);
	};

	const { data: order, refetch } = useQuery<IOrder, Error>(
		['product', orderNumber],
		() => getOrderByNumber(Number(orderNumber)),
	);

	useEffect(() => {
		console.log('orderL ', order, orderRetries, error);
		if (order) {
			console.log('order: ', order);
			if (order.status === ProductStatus.PENDING && orderRetries < 12) {
				refetchAfterTimeout(refetch);
			} else if (order.status === ProductStatus.PAID) {
				setIsRetryLoading(false);
				refetchUser();
				navigate(`${paths.userProfile.root}/${paths.userProfile.params.profile}`);
			} else {
				setIsRetryLoading(false);
				setError(true);
			}
		}
	}, [order, orderRetries]);

	const getLoaderText = () => {
		switch (orderRetries) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
				return 'Wait a moment, we are setting up your account...';
			case 6:
			case 7:
				return 'Couple of moments please...';
			case 8:
			case 9:
			case 10:
			case 11:
			case 12:
				return 'All good, we are just waiting for PayPal response...';
			default:
				return 'Sometimes it happens, no worries, just check your email if you received an invoice from Paypal. If so, just refresh / open our website again in couple of minutes and it should work!';
		}
	};

	return (
		<div
			style={{
				height: '150px',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
			}}
		>
			{error ? (
				<Typography variant="h6" style={{ marginBottom: '50px' }}>
					Something went wrong, please check your email. If you get an invoice,
					please{' '}
					<Link to={`${paths.userProfile.root}/${paths.userProfile.params.profile}`}>
						open your account page
					</Link>{' '}
					and verify your subscription plan. Otherwise, please{' '}
					<Link to={paths.contactUs}>contact us</Link>.
				</Typography>
			) : (
				<>
					<Typography variant="h6" style={{ marginBottom: '50px' }}>
						{getLoaderText()}
					</Typography>
					{isRetryLoading && <Loader />}
				</>
			)}
		</div>
	);
};

export default SubscriptionPayment;
